import { t } from "@lingui/macro"
import { FareCode } from "@silversea-ssc/web-fares-fp"
import * as F from "fp-ts/function"
import * as O from "fp-ts/Option"
import type { CurrencyCode } from "@silversea-ssc/dotcom-read-model-types/Currency"
import { CruisePaymentTermsResponse } from "../../_common/dot-com-api-types"
import { WebAppConfig } from "../../_common/web-app-config"
import { maybeFareCardByKey } from "./read-models/fare"
import { ECommerceContext, ECommerceFareSelectedContext } from "./machines/ecommerce-machine/e-commerce-machine-context"

export const paymentTermsUrl = (
    config: WebAppConfig,
    countryCode: string,
    currency: CurrencyCode,
    cruiseCode: string,
    fare: FareCode,
): string => {
    const url = new URL("cruisePaymentTerms", config.dotComApiBaseUrl)

    url.searchParams.set("countryCode", countryCode)
    url.searchParams.set("currency", currency)
    url.searchParams.set("fareCode", fare)
    url.searchParams.set("cruiseCode", cruiseCode)
    return url.href
}

export const paymentTermsDepositLabel = (paymentTerms: CruisePaymentTermsResponse): string => {
    switch (paymentTerms.depositType) {
        case "refundable": {
            return t({
                id: "deposit-refundable-label",
                message: `Deposit refundable`,
            })
        }

        case "nonRefundable":
            return t({
                id: "deposit-non-refundable-content",
                message: `Deposit not refundable`,
            })

        case "exchangeableForCredit":
            return t({
                id: "deposit-exchangeable-for-credit-content",
                message: `Deposit convertible to FCC*`,
            })
    }
}

export const maybePaymentTermsByFareCode = (
    context: ECommerceContext,
    fareCode: FareCode,
): O.Option<CruisePaymentTermsResponse> => O.fromNullable(context.paymentTerms[fareCode])

export const currentPaymentTerms = (context: ECommerceContext): O.Option<CruisePaymentTermsResponse> =>
    F.pipe(
        maybeFareCardByKey(context, context.selectedFare?.key),
        O.chain((fareCard) => maybePaymentTermsByFareCode(context, fareCard.fare)),
    )
